<mat-toolbar class="secondary-toolbar mat-elevation-z1">
  <div *ngIf="state!='LIST'" class="secondary-toolbar-item selectable" (click)="showAllAssessmentTemplates()"><mat-icon>list</mat-icon> All Assessments</div>
  <ng-container *ngIf="state=='EDIT'">
    <div class="secondary-toolbar-item"><mat-icon svgIcon="cw:action_next"></mat-icon>{{selectedAssessmentTemplate.name}}</div>
  </ng-container>
</mat-toolbar>

<section class="main-content">
  <cw-ci-admin-assessment-list #assessmentTemplateList *ngIf="state=='LIST'" (stateChange)="onStateChange($event)" ></cw-ci-admin-assessment-list>
  <cw-ci-admin-assessment-edit *ngIf="state=='EDIT' || state=='CREATE'" (stateChange)="onStateChange($event)" [assessment]="selectedAssessmentTemplate"></cw-ci-admin-assessment-edit>
</section>
